import React from 'react';
import { Icon, IconStack } from 'js/components';
import {
  faArrowsRotate,
  faFileChartLine,
} from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

export default function RegenerateBriefingIcon({ spin = false, className }) {
  return (
    <IconStack className={className}>
      <Icon icon={faFileChartLine} transform="left-2" />
      <Icon icon={faCircle} transform="shrink-6 right-5 down-4" />
      <Icon
        icon={faArrowsRotate}
        transform="shrink-9 right-5 down-4"
        spin={spin}
        inverse
      />
    </IconStack>
  );
}
